import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { UIRouterGlobals } from "@uirouter/core";
import { GetStartedModalService } from "../get-started-modal/get-started-modal.service";
import { PlanTierService } from "../plan-tier/plan-tier.service";
import { InstructionsModalService } from "../project-detail/instructions-modal/instructions-modal.service";
import { RememberService } from "../remember/remember.service";
import { SendDataModalService } from "../send-data-modal/send-data-modal.service";
import { UpgradeModalService } from "../upgrade-modal/upgrade-modal.service";

@Component({
  selector: "ab-project-deploys",
  templateUrl: "./project-deploys.component.html",
})
export class ProjectDeploysComponent implements OnInit {
  @Input() public project: any;
  @Input() public emptyProject: boolean;

  public chartType: string;
  public dur: string;
  public enabled: boolean;
  public environment: string;
  public featureDisabled: boolean;
  public lastN: number | string;
  public loadingComponents: number;
  public page: number;

  private REMEMBER_CHART_DURATION_KEY = "projectDeploys.chartDuration";
  private REMEMBER_CHART_LAST_N_KEY = "projectDeploys.chartLastN";

  constructor(
    private changeDetector: ChangeDetectorRef,
    private getStartedModalService: GetStartedModalService,
    private instructionsModalService: InstructionsModalService,
    private planTierService: PlanTierService,
    private rememberService: RememberService,
    private sendDataModalService: SendDataModalService,
    private upgradeModal: UpgradeModalService,
    public $uiRouterGlobals: UIRouterGlobals,
  ) {}

  public ngOnInit() {
    this.planTierService.features().subscribe((features: any) => {
      this.featureDisabled = !features.deploy_dashboard;
    });

    window.document.title = `${this.project.name} deploys`;

    this.enabled = false;
    this.loadingComponents = 0;

    this.chartType = this.$uiRouterGlobals.params.chartType;
    this.dur =
      this.$uiRouterGlobals.params.dur ||
      this.rememberService.get(this.REMEMBER_CHART_DURATION_KEY, "90d/1d");
    this.environment = this.$uiRouterGlobals.params.environment;
    this.lastN =
      this.$uiRouterGlobals.params.last_n ||
      this.rememberService.get(this.REMEMBER_CHART_LAST_N_KEY, "90");
    this.page = this.$uiRouterGlobals.params.page;

    if (this.emptyProject && !this.sendingDemoData()) {
      this.modalService().open();
    }
  }

  public uiOnParamsChanged(newParams: { [paramName: string]: any }) {
    if (newParams.chartType) {
      this.chartType = newParams.chartType;
    }
    if (newParams.dur) {
      this.dur = newParams.dur;
      this.rememberService.set(this.REMEMBER_CHART_DURATION_KEY, this.dur);
    }
    if (newParams.environment) {
      this.environment = newParams.environment;
    }
    if (newParams.last_n) {
      this.lastN = newParams.last_n;
      this.rememberService.set(this.REMEMBER_CHART_LAST_N_KEY, this.lastN);
    }
    if (newParams.page) {
      this.page = newParams.page;
    }
  }

  public hasData() {
    if (!this.emptyProject) {
      return true;
    }

    // When the feature is disabled, we generate sample data.
    return this.featureDisabled;
  }

  public openUpgradeModal($event: any) {
    this.upgradeModal.open($event);
  }

  public onLoading(count: number) {
    this.loadingComponents += count;
    this.enabled = this.loadingComponents === 0;
    this.changeDetector.detectChanges();
  }

  private modalService() {
    if (
      this.project.isFirstProject &&
      !this.project.demoModeUntilDate &&
      !this.rememberService.get("sendDataModalDismissed")
    ) {
      return this.sendDataModalService;
    }

    if (this.rememberService.get("getStartedModalDismissed")) {
      return this.instructionsModalService;
    }

    return this.getStartedModalService;
  }

  private sendingDemoData(): boolean {
    if (!this.project.demoModeUntilDate) {
      return false;
    }

    return new Date() < new Date(this.project.demoModeUntilDate);
  }
}
